import { financialConfirmationInterceptor } from 'shared-ui';
import { environment } from '../environments/environment';
import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import {
  APEX_THEME_STORAGE_KEY,
  APEX_THEME_STORAGE_KEYS,
  ApexPrimeNgPreset,
  ApexThemeService,
} from 'shared-ui';

import { routes } from './app.routes';
import { authExpiredInterceptor } from './core/interceptors/auth-expired.interceptor';
import { credentialsInterceptor } from './core/interceptors/credentials.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    { provide: APEX_THEME_STORAGE_KEY, useValue: APEX_THEME_STORAGE_KEYS.owner },
    provideAppInitializer(() => {
      inject(ApexThemeService);
    }),
    providePrimeNG({
      theme: {
        preset: ApexPrimeNgPreset,
        options: {
          darkModeSelector: "html[data-theme='dark']",
        },
      },
    }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withFetch(), withInterceptors([financialConfirmationInterceptor(environment.apiGatewayUrl), credentialsInterceptor, authExpiredInterceptor])),
  ],
};
